export const tailwindPreflight = "alaffia-tailwind-preflight";
